import get from "lodash/get";
import React from "react";
import { ResponsiveHeroImage } from "@quintype/components";
import { loadRelatedStories } from "./related-stories-helper";
import { ImageFallback } from "../basic/image-fallback.js";
import { altTagOfHeroImages, isExternalStory } from "../../utils";
import PropTypes from "prop-types";

function getImageFallback(props) {
  if (!props.showImage) return null;
  return props.showImage && props.story["hero-image-s3-key"] ? (
    <figure className="story-card-image">
      <ResponsiveHeroImage
        story={props.story}
        aspectRatio={[16, 9]}
        alt={altTagOfHeroImages(props.story)}
        defaultWidth={480}
        widths={[250, 480, 640]}
        sizes="(max-width: 500px) 98%, (max-width: 768px) 48%, 98%"
        imgParams={{ auto: ["format", "compress"], fit: "max" }}
      />
    </figure>
  ) : (
    <ImageFallback className="story-card__image story-card__image--cover" />
  );
}
getImageFallback.propTypes = {
  story: PropTypes.shape({
    story: PropTypes.object,
    "hero-image-s3-key": PropTypes.string,
    slug: PropTypes.string,
    headline: PropTypes.string,
    "author-name": PropTypes.string
  }),
  showImage: PropTypes.bool
};

function RelatedStoryCard(props) {
  const classname = props.showImage ? "story-title story-title-bold" : "story-title";
  const externalLink = isExternalStory(props.story);
  // The `props.story` can be an item from items of a collection or a story itself.
  // assigning it accordinlgy.
  return !props.story ? null : (
    <div className="related_stories-story-card">
      <a href={externalLink || `/${props.story.slug}`} target={externalLink ? "_blank" : "_self"}>
        {getImageFallback(props)}
        <h2 className={classname}>
          <bdi dangerouslySetInnerHTML={{ __html: props.story.headline }} />
        </h2>
        <div className="author-title">{get(props.story, ["authors", 0, "name"], props.story["author-name"])}</div>
      </a>
    </div>
  );
}
RelatedStoryCard.propTypes = {
  story: PropTypes.shape({
    story: PropTypes.object,
    slug: PropTypes.string,
    headline: PropTypes.string,
    "author-name": PropTypes.string
  }),
  showImage: PropTypes.bool
};
class RelatedStories extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      relatedStories: []
    };
  }

  updateRelatedStories(story) {
    loadRelatedStories(story).then(relatedStories => {
      this._isMounted &&
        this.setState({
          relatedStories: relatedStories
        });
    });
  }

  componentDidMount() {
    this._isMounted = true;
    this.updateRelatedStories(this.props.story);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getRelatedStoryTemplate() {
    const textStory = get(this.props, ["config", "theme-attributes", "text-story"], "");
    switch (textStory) {
      case "photo-priority":
        return this.getHorizontalRelatedStories();
      case "photo-low-priority":
        return this.getVerticalRelatedStories();
      default:
        return this.getVerticalRelatedStories();
    }
  }

  getVerticalRelatedStories() {
    const { relatedStories = [] } = this.state;
    const [firstStory, ...remainingStories] = relatedStories;
    return (
      <div className="related_stories" data-testid="related-stories">
        <h4 className="related_stories-heading"> Related Stories </h4>
        <RelatedStoryCard story={firstStory} showImage={true} />
        {(remainingStories || []).map(story => (
          <RelatedStoryCard key={story.id} story={story} showImage={false} />
        ))}
      </div>
    );
  }

  getHorizontalRelatedStories() {
    return (
      <div className="related-story-content">
        <h4 className="related_stories-heading"> Related Stories </h4>
        <div className="related_stories" data-testid="related-stories">
          {this.state.relatedStories.map(story => (
            <RelatedStoryCard key={story.id} story={story} showImage={true} />
          ))}
        </div>
      </div>
    );
  }

  render() {
    return !this.state.relatedStories || !this.state.relatedStories.length ? null : this.getRelatedStoryTemplate();
  }
}
RelatedStories.propTypes = {
  story: PropTypes.object
};

export { RelatedStories };
